import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconArrowDown({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd'>
                <g fillRule='nonzero' fill={color}>
                    <g transform='rotate(-90 12 12)'>
                        <g transform='translate(7 3)'>
                            <path d='M8.29289322,0.292893219 L0.292893219,8.29289322 C-0.0976310729,8.68341751 -0.0976310729,9.31658249 0.292893219,9.70710678 C0.683417511,10.0976311 1.31658249,10.0976311 1.70710678,9.70710678 L9.70710678,1.70710678 C10.0976311,1.31658249 10.0976311,0.683417511 9.70710678,0.292893219 C9.31658249,-0.0976310729 8.68341751,-0.0976310729 8.29289322,0.292893219 Z' />
                            <path d='M0.292893219,9.70710678 L8.29289322,17.7071068 C8.68341751,18.0976311 9.31658249,18.0976311 9.70710678,17.7071068 C10.0976311,17.3165825 10.0976311,16.6834175 9.70710678,16.2928932 L1.70710678,8.29289322 C1.31658249,7.90236893 0.683417511,7.90236893 0.292893219,8.29289322 C-0.0976310729,8.68341751 -0.0976310729,9.31658249 0.292893219,9.70710678 Z' />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
